import type { ShippingMethod } from '~/repository/modules/ShippingMethod.module';

export const STEP3_ADDRESS_PERSONAL_EMAIL = 'step3_address_personal_email';
export const STEP3_SHIPPING_METHODS_RADIO_GROUP =
  'step3_shipping_methods_radio_group';
export const STEP3_SHIPPING_METHODS_LOCKER_RADIO_GROUP =
  'step3_shipping_methods_locker_radio_group';
export const STEP3_SHIPPING_INSTABOX_PHONE_NUMBER =
  'step3_shipping_instabox_phone_number';

export interface Step3FormValues {
  [STEP3_ADDRESS_PERSONAL_EMAIL]: string;
  [STEP3_SHIPPING_METHODS_RADIO_GROUP]?: ShippingMethod;
  [STEP3_SHIPPING_INSTABOX_PHONE_NUMBER]?: string;
}
